import { render, staticRenderFns } from "./ProdOrderCheckoutPanel.vue?vue&type=template&id=9a836b68&scoped=true&"
import script from "./ProdOrderCheckoutPanel.vue?vue&type=script&lang=js&"
export * from "./ProdOrderCheckoutPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a836b68",
  null
  
)

export default component.exports